export class ProgressIndicatorList {
  public name: string;
  public complete: boolean;
  public show: boolean;
  public skipped: boolean;
  public active: boolean;
  public title: string;
  public route: string;
}
